<!-- Content -->
<div #pageContentDiv class="backdrop-blur-2xl max-w-lg md:max-w-6xl mx-auto min-h-[calc(100vh)] bg-theme-surface-95">
  <div class="pb-44 bg-transparent text-theme-text pt-16 md:pt-0">
    <div *ngIf="topImage" class="p-4 md:px-0 md:pt-0" >
      <img class="w-full object-cover h-52 md:h-72 lg:h-96 rounded-2xl md:rounded-none" src="https://storage.googleapis.com/heynow/danilo/place-holder.gif" [appHires]="topImage">
    </div>
    <div *ngIf="!topImage" class="h-6 md:h-20"></div>

    @if (prebookMenu && compactMenu) {
      <!-- A compact prebook guest menu reads like a menu: its categories as headings, a row per dish, in a column of
           reading width on tablets and two columns of dishes on large screens -->
      <div class="md:max-w-2xl lg:max-w-5xl md:mx-auto md:pt-6">
        <app-prebook-banner></app-prebook-banner>
        <div class="px-4">
          <div class="px-3 pb-4">
            <div class="text-3xl font-bold font-custom" [style]="themeService.customFontStyle">{{ prebookMenu.name }}</div>
            @if (prebookMenu.note) {
              <div class="text-lg text-theme-text3 pt-2 whitespace-pre-line">{{ prebookMenu.note }}</div>
            }
          </div>
          @for (category of visibleRootCategories; track category.id) {
            @if (category.name !== prebookMenu.name || visibleRootCategories!.length > 1) {
              <div class="text-2xl px-3 pt-6 font-bold font-custom" [style]="themeService.customFontStyle">{{ category.name }}</div>
            }
            @if (category.desc) {
              <div class="text-base px-3 text-theme-text3 pt-1">{{ category.desc }}</div>
            }
            <div class="border-b mt-3 border-theme-divider"></div>
            <div class="lg:grid lg:grid-cols-2 lg:gap-x-10">
              @for (item of getVisibleItems(category); track item.id) {
                <button class="flex w-full items-start gap-3 text-left px-3 py-4 border-b border-theme-divider sm:hover:bg-theme-surface2-hover"
                        (click)="displayItem(item)">
                  <div class="flex-1 min-w-0">
                    <div class="text-lg font-bold break-words">{{ item.name }}</div>
                    @if (item.currentStockState) {
                      <div class="text-theme-notification2 font-medium">{{ getString("Slutsåld") }}</div>
                    }
                    @if (item.desc) {
                      <div class="text-base text-theme-text2 line-clamp-2">{{ item.desc }}</div>
                    }
                  </div>
                  <div class="text-lg font-medium text-theme-text2 tabular-nums whitespace-nowrap">{{ getPrice(item) }}</div>
                  <div class="relative w-8 h-8 shrink-0 rounded-full bg-theme-surface2 flex justify-center items-center">
                    <i class="fas fa-plus text-sm"></i>
                    @if (item.currentOrderCount > 0) {
                      <div class="absolute -top-2 -right-2 text-theme-notification2-text bg-theme-notification2 rounded-full w-5 h-5 flex justify-center items-center text-xs font-bold">{{ item.currentOrderCount }}</div>
                    }
                  </div>
                </button>
              }
            </div>
          }
        </div>
      </div>
    } @else {
    <app-prebook-banner></app-prebook-banner>
    @if (prebookMenu) {
      <div class="px-7 pb-4">
        <div class="text-3xl font-bold font-custom" [style]="themeService.customFontStyle">{{ prebookMenu.name }}</div>
        @if (prebookMenu.note) {
          <div class="text-lg text-theme-text3 pt-2 whitespace-pre-line">{{ prebookMenu.note }}</div>
        }
      </div>
    }
    <!-- Responsive grid container for categories -->
    <div class="px-3">
      <div *ngFor="let category of visibleRootCategories">
        <div class="text-3xl px-4 pt-2 font-bold font-custom" [style]="themeService.customFontStyle">{{ category.name }}</div>
        <div *ngIf="category.desc" class="text-lg px-4 text-theme-text3 pt-2 font-regular">{{ category.desc }}</div>
        <div class="border-b mt-4 border-theme-divider"></div>
        <!-- Grid for the items within a category -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div *ngFor="let item of getVisibleItems(category)" class="px-4 py-6">
            <app-menu-item [item]="item" [count]="item.currentOrderCount" [outOfStock]="item.currentStockState" (onClick)="displayItem(item)" [showWhen]="showWhen"></app-menu-item>
          </div>
        </div>
      </div>
    </div>
    }

    <!-- Responsive grid container for sections -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 px-4 pt-4">
      <button *ngFor="let section of sectionsExludingRoot; let i = index"
              [ngClass]="{'border-theme-outline border-2': displayOutine}"
              class="flex min-h-14 bg-theme-surface2 rounded-lg justify-start items-start py-2 px-4
              sm:hover:bg-theme-surface2-hover
              active:scale-95
              active:bg-theme-surface2-active
              transition-all" (click)="selectSection(section.id)" >
        <div class="flex w-full min-h-[inherit] md:min-h-24">
          <div class="flex-1 flex flex-col items-start text-start">
            <div class="font-bold text-lg">{{ section.name }}</div>
            <div *ngIf="section.desc" class="text-base font-bold text-theme-text2">{{ section.desc }}</div>
          </div>
          <div class="w-6 flex justify-center items-center">
            <i class="fas fa-chevron-right"></i>
          </div>
        </div>
      </button>
    </div>
  </div>
</div>
<div class="scrollfooter"></div>

<app-order-page-nav [selectedPageId]="pageId || ''"></app-order-page-nav>
